import { forwardRef, useImperativeHandle, useRef } from "react";

const Modal = forwardRef(({ children, onClose, title }, ref) => {
  const dialogRef = useRef(null);

  useImperativeHandle(ref, () => ({
    open() {
      dialogRef.current.showModal();
    },
    close() {
      dialogRef.current.close();
      // Do not call `onClose` here to prevent recursion
    },
  }));

  const handleUserClose = () => {
    dialogRef.current.close();
    if (onClose) onClose(); // Only trigger `onClose` when user interacts
  };

  return (
    <dialog ref={dialogRef} className="p-6 bg-white rounded-lg w-1/3">
      <button
        onClick={handleUserClose}
        className="absolute top-2 right-2 text-gray-600 text-3xl"
      >
        &times;
      </button>
      <h2 className="text-xl font-bold mb-4">{title}</h2>
      {children}
    </dialog>
  );
});

export default Modal;
